import {CenterHero} from "../../blocks/hero/Hero";
import {Footer} from "../../blocks/footer/Footer";
import {useEffect} from "react";

export default function NewsletterPage(){

    useEffect(()=>{
        setTimeout(()=>{
            var section = document.getElementById('newsletter');
            const nav = document.querySelector('nav');
            if (section) {
                // kiszámoljuk a nav magasságát
                const navHeight = nav ? nav.offsetHeight : 0;

                // lekérjük a szekció pozícióját az oldalon
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;

                // smooth scroll nav magasság mínusszal
                window.scrollTo({
                    top: sectionTop - navHeight, // nav magasságával korrekció
                    behavior: 'smooth'
                });
            }
        },500)
    })
    return (
        <>
            <CenterHero
                url={'/benefitshare/img/headerbg3.jpg'}
                megaphone={'Shaping success, sharing great ideas'}
                titles={['Jegyvásárlás']}
                fill={'#f0f2f8'}
            ></CenterHero>
            <section id={'newsletter'}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 last-paragraph-no-margin"
                             data-anime={JSON.stringify({
                                 "el": "childs",
                                 "translateY": [50, 0],
                                 "opacity": [0, 1],
                                 "duration": 1200,
                                 "delay": 0,
                                 "staggervalue": 150,
                                 "easing": "easeOutQuad"
                             })}>
                            <h5 className="alt-font fw-600 text-dark-gray">Sikeres feliratkozás!</h5>
                                <p>
                                    Köszönjük szépen a hírlevél feliratkozást!<br/>
                                    Üdvözlettel,<br/>
                                    a BeneFit SHARE csapata<br/>
                                </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>
    )
}